import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TransactionFilter from '../components/filters/transaction-filter';
import TransactionsTable from '../components/tables/transactions-table';

const TransactionsListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="تراکنش ها"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/transactions-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <TransactionFilter onFinish={setFitlers} />
    <TransactionsTable filters={filters} />
  </>);
}

export default TransactionsListRoute;
